@if (supportModeStore.isActive() && !isCustomerScreen) {
  <app-alert
    class="support-mode-banner d-block"
    type="warning"
    [title]="'Support Mode' | trans:'app/support-mode-banner.Title'"
    [message]="'You are currently viewing the system with customer permissions.' | trans:'app/support-mode-banner.Message'"
  />
}
